import { NEWS_BASE_URL } from '../../constants/endpoint'
import { ICommunityNewsSearchResults } from '../models/communityNews.model'

export async function getCommunityNews(pageIndex: number, communityNewsListingPageIs: string): Promise<any> {
  let response = await fetch(
    `${NEWS_BASE_URL}/getcommunitynews?communityNewsListingPageId=${communityNewsListingPageIs}&pageIndex=${pageIndex}`,
  )

  const jsonResults = await response.json()
  return <ICommunityNewsSearchResults>jsonResults
}
